module.exports = __webpack_public_path__ + "static/media/src_image_vip_icon_zhibo.a2853e93.png";